package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.TextBodyTiny
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun IconText(
    icon: DrawableResource,
    text: String,
    tint: Color = LocalAppTheme.current.color.icon.subtle,
    iconSize: Dp = LocalAppTheme.current.dimension.size.icon.xs,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    isTiny: Boolean = false,
    bold: Boolean = false,
    textColor: Color = LocalAppTheme.current.color.text.subtle
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(
            if (isTiny) dimension.spacing.space1 else dimension.spacing.space2
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = painterResource(icon),
            tint = tint,
            modifier = Modifier.size(if (isTiny) dimension.spacing.space3 else iconSize),
            contentDescription = text,
        )
        if (isTiny) {
            TextBodyTiny(text = text, color = { textColor }, bold = bold)
        } else {
            TextBodySmall(text = text, color = { textColor }, bold = bold)
        }
    }
}
